import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	ICheckKaiAssistantNameDTO,
	ICreateKaiAssistantDTO,
	IGetKaiAssistantByUserDTO,
	IKaiAssistantDTO,
	IUpdateKaiAssistantDTO,
} from '@interfaces/kai/dto/kaiDTO';
import { IShortUserInfo } from '@interfaces/user/user';

export function getKaiAssistants(organizationId: string): Promise<IKaiAssistantDTO[]> {
	return client.get(`organizations/${organizationId}/kai-assistant/get-all`);
}

export function getKaiAssistantByUser(params: IGetKaiAssistantByUserDTO): Promise<IKaiAssistantDTO> {
	return client.get(URL.kaiAssistantByUser, { params });
}

export function createKaiAssistant(kaiAssistant: ICreateKaiAssistantDTO): Promise<void> {
	return client.post(`${URL.kaiAssistants}/create`, kaiAssistant);
}

export function updateKaiAssistant(kaiAssistant: IUpdateKaiAssistantDTO): Promise<void> {
	return client.post(`${URL.kaiAssistants}/${kaiAssistant.id}/update`, kaiAssistant);
}

export function deleteKaiAssistant(id: string): Promise<void> {
	return client.post(`${URL.kaiAssistants}/${id}/delete`, {});
}

export function enableKaiAssistant(id: string): Promise<void> {
	return client.post(`${URL.kaiAssistants}/${id}/enable`, {});
}

export function disableKaiAssistant(id: string): Promise<void> {
	return client.post(`${URL.kaiAssistants}/${id}/disable`, {});
}

export function hideKaiAssistant(organizationId: string): Promise<void> {
	return client.post(`organizations/${organizationId}/kai-assistant/hide`, {});
}

export function unhideKaiAssistant(organizationId: string): Promise<void> {
	return client.post(`organizations/${organizationId}/kai-assistant/unhide`, {});
}

export function getKaiNotAssignedUsers(organizationId: string): Promise<IShortUserInfo[]> {
	return client.get(`organizations/${organizationId}/kai-assistant/get-all-not-assigned-users`);
}

export function enableKaiAssistants(organizationId: string): Promise<IKaiAssistantDTO[]> {
	return client.post(`organizations/${organizationId}/kai-assistants-enable`, {});
}

export function disableKaiAssistants(organizationId: string): Promise<IKaiAssistantDTO[]> {
	return client.post(`organizations/${organizationId}/kai-assistants-disable`, {});
}

export function setDefaultKaiAssistant(id: string): Promise<IKaiAssistantDTO[]> {
	return client.post(`organizations/kai-assistant/${id}/set-default`, {});
}

export function setNonDefaultKaiAssistants(id: string): Promise<IKaiAssistantDTO[]> {
	return client.post(`organizations/kai-assistant/${id}/set-non-default`, {});
}

export function getKaiAssistantById(id: string): Promise<IKaiAssistantDTO> {
	return client.get(`${URL.kaiAssistants}/${id}`);
}

export function checkKaiAssistantName({ id, name, organizationId }: ICheckKaiAssistantNameDTO): Promise<void> {
	return client.post(`${URL.kaiAssistants}/check-name`, {
		id,
		name,
		organizationId,
	});
}
